const chartOptions = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      color: (context) => context.dataset.borderColor,
      anchor: "top",
      align: "top",
      font: {
        weight: "bold",
        size: 12,
      },
      formatter: function (value) {
        return `${value.toFixed(2)}% ▲`;
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  scales: {
    x: {
      ticks: {
        color: "white",
      },
      border: {
        color: "#FFFFFF",
      },
      grid: {
        display: false,
      },
    },
    y: {
      ticks: {
        display: false,
      },
    },
  },
};

const icons = [
  {
    src: new URL("@/assets/bg/product.png", import.meta.url).href,
    label: "Продукт",
  },
  {
    src: new URL("@/assets/bg/ttk.png", import.meta.url).href,
    label: "ТТК",
  },
  {
    src: new URL("@/assets/bg/tara.png", import.meta.url).href,
    label: "Тара",
  },
  {
    src: new URL("@/assets/bg/material.png", import.meta.url).href,
    label: "Материал",
  },
];
export default {
  chartOptions,
  icons,
};
